import React, { Component } from 'react';
import { Dispatch } from 'architecture'
import _ from 'lodash'
import DatePicker from 'react-datepicker';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { faTags } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { faBan } from '@fortawesome/free-solid-svg-icons'
//import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import Linkify from 'react-linkify'
import DropZone from 'react-dropzone'
import moment from 'moment'

import TagInput from './TagInput/TagInput'
import Auth from './Auth'

import loadingsvg from '../media/loading.svg'
import logo from '../media/logo.svg'
import Tag from './TagInput/Tag'
import Sidebar from './Sidebar'
import Stream from './Stream'

import Select from 'react-select';

const displayHeight = '350px'

const ImageInstance = (url) => {
  return (
    <div style={{height: displayHeight}}>
      <img style={{maxHeight: displayHeight}} className='pt1' src={url}  alt="Logo" />
    </div>
  )
}

const EmbedInstance = (url) => {
  return (
    <div>
      <embed style={{height: displayHeight}} className='pt1 w-100' src={url}  alt="Logo" />
    </div>
  )
}

const VideoInstance = (url) => {
  return (
    <div key={url} className='bg-black'>
      <video key={url} style={{height: displayHeight}} className='pt1 w-100' src={url}  alt="Logo" controls/>
    </div>
  )
}

const LinkInstance = (url) => {
  return (
    <div>
      <Linkify>{ url } </Linkify>
    </div>
  )
}

const FileInstance = (props) => {
  //console.log(props.data.key)
  //const
  //console.log(Storage.get(props.data.key && props.data.key.split('/') && props.data.key.split('/')[1], { level: 'public' }))
    // .then(e => {
    //   console.log("NEW ENTRY")
    //   console.log(e)
    //   // var http = new XMLHttpRequest();
    //   // http.open('HEAD', e);
    //   // http.onreadystatechange = function(f) {
    //   //     //console.log(this)
    //   //     //console.log(f)
    //   //     if (this.readyState === this.DONE) {
    //   //         console.log(this)
    //   //         //callback(this.status !== 404);
    //   //     }
    //   // };
    //   // http.send();
    // })
    const fileType = props.data.fileType
    const url = props.data.authUrl
    const types = {
      image: ImageInstance,
      application: {
        pdf: EmbedInstance,
        'vnd.openxmlformats-officedocument.spreadsheetml.sheet': LinkInstance,
      },
      video: {
        mp4: VideoInstance,
      },
    }
    const getType = (fileType) => {
      return fileType.split('/').reduce((acc, next) => acc[next] ? acc[next] : acc, types)
    }
  return (
    <div key={props.data.stateId}>
      { getType(fileType)(url) }
      {/* <embed className='pt1 mw5' src={props.data.key}  alt="Logo" /> */}
    </div>
  )
}

class Input extends Component {
  constructor(props) {
    super (props)
    this.state = {
      text: this.props.data.text
    }
  }
  render() {
    const stateId = this.props.stateId ? this.props.stateId : null
    const buffer = this.props.buffer && this.props.buffer[stateId] ? this.props.buffer[stateId] : null
    return(
      <div
        key={stateId}
        onBlur={e => Dispatch.nextAction('buffer', 'update', { stateId: stateId, name: 'text', value: e.currentTarget.textContent, type: 'textInstance' })}
        className='' 
        style={{minHeight: 25, outline: 'none'}} 
        contentEditable="true">
          {/* <Linkify>{props.data.text}</Linkify> */}
          {this.state.text}
      </div>
    )
  }
}

const TextInstance = (props) => {
  const stateId = props.stateId ? props.stateId : null
  const buffer = props.buffer && props.buffer[stateId] ? props.buffer[stateId] : null
  const saving = props.buffer && props.buffer[stateId] && props.buffer[stateId].saving ? true : false
  return (
    <div>
      {/* <Input {...props} /> */}
      <div
        key={stateId}
        onFocus={e =>Dispatch.nextAction('buffer', 'update', { stateId: stateId, name: 'text', value: e.currentTarget.textContent, type: 'textInstance' })}
        onBlur={e => Dispatch.nextAction('buffer', 'update', { stateId: stateId, name: 'text', value: e.currentTarget.textContent, type: 'textInstance' })}
        className='' 
        style={{minHeight: 25, outline: 'none'}} 
        contentEditable="true"
        >
          {/* <Linkify>{props.data.text}</Linkify> */}
          {props.data.text}
      </div>
      {/* <div className='fw4 fw3-ns'><Linkify>{props.data.text}</Linkify></div> */}
      { buffer ? 
        <div className='w-100 flex justify-between'>
          <div></div>
          {
            saving ? 
            <div className='h2 flex items-center justify-center'>
              <img className='h2' alt='loading' src={loadingsvg}/>
            </div> 
            :
          <div className='flex black f3'>
            <div className='mr4 pointer' onClick={e => Dispatch.nextAction('buffer', 'cancel', stateId )}>
              <FontAwesomeIcon icon={faBan}/>
            </div>
            <div className='mr4 pointer' onClick={e => Dispatch.nextAction('buffer', 'save', stateId )}>
              <FontAwesomeIcon icon={faCheckCircle}/>
            </div>
          </div>
          }
        </div>
        :
        null
      }
    </div>
  )
}

const Column = (props) => {
  const header = props.data.header
  const target = props.data.target
  const items = [props.data[target]]
  const size = props.data.size
  const type = props.data.type
 // const refId = props.data.refId
  const stateId = props.stateId
  //const date = !_.isNil(sample[props.detail.input]) ? moment(sample[props.detail.input]) : null
  return (
    <div className='flex flex-column' style={{flexGrow:size}}>
      <div className='ph2 pb1 fw4 fw3-ns f6'>
        {header}
      </div>
      {items.map(item => 
        <div className='br b--white bg-near-white flex items-center h3'>
          {
            type === 'date' ? 
            <div className='flex items-center w-100'>  
              <DatePicker
                className='pv1 w-100'
                selected={!_.isNil(item) ? new Date(item) : null}
                onChange={e => {
                  Dispatch.nextAction('task', 'update', { column: target, stateId: stateId, value: e.toString() }) }
                }
              />
            </div>
            :
          <input 
            className='input-reset w-100 h3 ph2 pl1 w-100 bn bg-transparent'
            onChange={e => Dispatch.nextAction('task', 'update', { column: target, stateId: stateId, value: e.target.value }) }
            style={{outline: 'none'}} 
            defaultValue={item}
             />
          }
        </div>
      )}
    </div>
  )
}

const Column2 = (props) => {
  const header = props.data.header
  const target = props.data.target
  const items = [props.data[target]]
  const size = props.data.size
  const type = props.data.type
 // const refId = props.data.refId
  const stateId = props.stateId
  //const date = !_.isNil(sample[props.detail.input]) ? moment(sample[props.detail.input]) : null
  return (
    <div className='flex flex-column white' style={{flexGrow:size}}>
      <div className='mt2 pt2 ph3 fw7 fw7-ns f6'>
        {header}
      </div>
      {items.map(item => 
        <div className='flex items-center ph3 white'>
          {
            type === 'date' ? 
            <div className='flex items-center w-100'>  
              <DatePicker
                className='pv2 w-100'
                selected={!_.isNil(item) ? new Date(item) : null}
                onChange={e => {
                  Dispatch.nextAction('task', 'update', { column: target, stateId: stateId, value: e.toString() }) }
                }
              />
            </div>
            :
            <div className='w-100 '>
              <input 
                className='input-reset w-100 pv2 w-100 bn bg-transparent white'
                onChange={e => Dispatch.nextAction('task', 'update', { column: target, stateId: stateId, value: e.target.value }) }
                style={{outline: 'none'}} 
                defaultValue={item}
                />
             </div>
          }
        </div>
      )}
    </div>
  )
}

const TaskInstance = (props) => {
  const stateId = props.stateId
  const completeStyle = props.data && props.data.open ? ' moon-gray ' : ' green '
  return (
    <div className='pb4 br3 bg-gray'>
      <div className='w-100 flex justify-between items-center'>
        <div className='pt2 pb1 ph3 f3 fw6 white'>Task</div>
        <div className='pt1 ph3 f3 fw6 flex items-center'>
          <span className='pr2 f5 fw4 white'>Complete? </span> <div className={ 'pointer ' + completeStyle } onClick={e => Dispatch.nextAction('task', 'update', { column: 'open', value: false })}><FontAwesomeIcon icon={faCheckCircle}/></div>
        </div>
      </div>
      <div className='w-100 bg-white' style={{height:1}}></div>
      <div className='fw4 fw3-ns flex flex-column'>
        <Column2 key={'asdfasdf'} {...props} data={{...props.data, header: 'Description', target:'description', size:'2' }}/>
        {/* <Column2 key={'fkasdfkd'} {...props} data={{...props.data, header: 'Status', target:'status', type: 'dropdown', size:'1' }}/> */}
        <Column2 key={'asdfkfk'} {...props} data={{...props.data, header: 'Due', target:'dueDate', type: 'date', size:'1' }}/>
      </div>
      {/* <div className='pv2 fw4 fw3-ns flex flex-column'>
        
      </div> */}
      { props.data.saved === false ? 
        <div className='w-100 flex justify-between'>
          <div></div>
          <div className='flex white f3'>
            <div className='mr4 pointer' onClick={e => Dispatch.nextAction('task', 'cancel', { stateId: stateId })}>
              <FontAwesomeIcon icon={faBan}/>
            </div>
            <div className='mr4 pointer' onClick={e => Dispatch.nextAction('task', 'save', { stateId: stateId })}>
              <FontAwesomeIcon icon={faCheckCircle}/>
            </div>
          </div>
        </div>
        :
        null
      }
    </div>
  )
}

const UpdateInstance = (props) => {
  return (
    <div>
      
    </div>
  )
}

const instanceTypes = {
  ImageInstance,
  TextInstance,
  TaskInstance,
  UpdateInstance,
  FileInstance,
}

export default (props) => {
  const tagInputs = props.TagInput ? props.TagInput : {}
  const search = props.Search ? props.Search : {}
  const streamInput = props.StreamInput ? props.StreamInput : {}
  const stateBuffer = props.StateBuffer ? props.StateBuffer : false
  const orderedStates = props.OrderedStates ? props.OrderedStates : {}
  const states = orderedStates.states ? orderedStates.states : {}
  const order = orderedStates.order ? orderedStates.order : []
  //const loading = props.RawStates ? props.RawStates === null ? true : false : true
  const loadingMore = props.ui && !_.isNil(props.ui.loadingMore) ? props.ui.loadingMore : true
  const loadingAll = props.ui && !_.isNil(props.ui.loadingAll) ? props.ui.loadingAll : true

  const viewAs = props.ui.viewAs ? props.ui.viewAs : { value: 'stream', label: 'Stream' }
  const options = [
    { value: 'stream', label: 'Stream' },
    { value: 'latest', label: 'Latest' },
  ];
  return (


<div className='center w-100 avenir center flex flex-column'>
{loadingAll ?
  <div className='flex items-center justify-center'>
    <img className='h4' alt='loading' src={loadingsvg}/>
  </div> 
:
<div className='pa2'>
  {/* <div className='absolute flex w-100 justify-center' style={{zIndex: 12}}>
    <div className='w5 h2 bg-red'>
      <Select
        value={viewAs}
        onChange={e => Dispatch.nextAction('UI', 'viewAs', e)}
        options={options}
      />
    </div>
  </div> */}
  <div className='w-100 h-100'>
    {loadingMore ? 
      <div className='flex items-center justify-center'>
        <img className='h4' alt='loading' src={loadingsvg}/>
      </div>
      :
      null
    }
    {/* <div className='pv5 w-100 tc f4 fw6 underline' onClick={e => Dispatch.nextAction('UI', 'load')}>Load More</div> */}
    {order.map((key, index) => {
      const state = states[key]
      const createdAt = moment(state.createdAt).format('MMM Do YYYY, h:mm')
      return (
      <div id={state.id} key={state.id} className='pv3 ph3 w-100 feed'>
        <div className='pb1 w-100 flex justify-between'>
          <div className=' flex'>
            <div className='f5 fw6'>{state.creator.name}</div>
            <div className='relative pl1 gray f6 fw3' style={{top:2}}>{createdAt}</div>
            <div className='relative pl1 gray f6 fw3' style={{top:2}}>{state.lastModifiedBy ? '(modified: ' + state.lastModifiedBy + ')' : null}</div>
          </div>
          <div className='mr4 moon-gray pointer' >
            {/* onClick={e => Dispatch.nextAction('task', 'temp', {id: state.id, value: state.instance.text})}> */}
            <FontAwesomeIcon icon={faEllipsisH}/>
          </div>
        </div>
        {state.message ? <div className='pt2 red'>{state.message}</div> :
        <div>
          <TagInput {...props} key={state.id + 'hi'} data={{ ...tagInputs[state.id], target: 'TagInput', tags: state.object.tags, mini: true }}/>
          <div className='mt2 fw3'>{instanceTypes[state.instance.__typename]({...props, stateId: state.id, data: { ...state.instance, ids: { index, state: state.id, object: state.object.id } } })}</div>
        </div>
        }
        {/* { entry.instance ? 
          <div className='pt1 fw3'>{entry.instance(props)}</div>
        :
        null
        } */}
      </div>
      )})
    }
    
  </div>
  {/* Dont render footer if no order oject */}
  {order.length > 0 ?
    <div id='scrollToFooter' className=''></div>
    :
    null
  }
</div>
}
{/* <Auth {...props} /> */}
{ stateBuffer ? 
  <div className='h4 flex items-center justify-center'>
    <img className='h4' alt='loading' src={loadingsvg}/>
  </div> 
  : 
  null }
</div>

  )
}